import type { IconProps } from '@iconify/react'
import { Icon } from '@iconify/react'
import './index.css'

const Iconify = ({ className, style, ...props }: IconProps) => (
  <span
    aria-label={props.icon as string}
    className={clsx('anticon', `anticon-${props.icon}`, className)}
    role="img"
    style={style}
  >
    <Icon {...props} />
  </span>
)

export default Iconify
